import * as THREE from "three";

export class ViewTile {
    static BASE_GEOMETRY = new THREE.BoxGeometry(1, 0.3, 1);

    model;
    material;
    mesh;

    constructor(scene, color, model) {
        this.model = model;
        this.material = new THREE.MeshPhysicalMaterial({
            color: color,
        });
        this.mesh = new THREE.Mesh(ViewTile.BASE_GEOMETRY, this.material);
        this.mesh.renderOrder = 0;

        scene.add(this.mesh);
    }

    getColor() {
        return this.material.color;
    }

    setColor(threeColor) {
        this.material.color.set(threeColor);
    }

    setMeshCoordinates(x, y, z) {
        this.mesh.position.set(x, y, z);
    }

    getX() {
        return this.model.x;
    }

    getY() {
        return this.model.y;
    }

    dispose() {
        if (!this.mesh) return;

        if (this.mesh.parent) {
            this.mesh.parent.remove(this.mesh);
        }

        if (this.material) {
            this.material.dispose();
            this.material = null;
        }

        this.model = null;
        this.mesh = null;
    }
}